import type { User } from '../auth/types';

/**
 * Permission helpers for spray-session UI surfaces.
 *
 * Track: spray_session_ui_changes_20260502 / Phase 1 / Task 1.
 *
 * Status semantics in the spray-session schema split into two buckets:
 *   active        — `draft`, `planned`           (anyone with edit ability)
 *   terminal-ish  — `completed`, `cancelled`,
 *                   `deleted`, `in_progress`     (admins only)
 *
 * Editing a session that has reached the terminal-ish bucket is restricted
 * to Super Admins (user.superadmin) and Farm Administrators
 * (role.isFarmAdministrator). The Farm Administrator role is system-protected
 * (only Super Admins can assign it), so the boolean flag is a reliable
 * authorization signal on the frontend.
 */

/**
 * Returns true when the supplied user is permitted to edit a spray session
 * that has reached the terminal-ish status bucket. The check is purely
 * UI-side gating; the backend remains the source of truth for any write.
 */
export function canEditTerminalSpraySession(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.superadmin) return true;
  return Boolean(user.role?.isFarmAdministrator);
}
